export default __webpack_public_path__ + "58f20393bf2b41f944c6229c2af785b9.svg";